import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import api from "@/lib/axios"
import SkeletonTable from "@/components/SkeletonTable"
import { useSearchParams } from "react-router-dom"
import { RuangCbtDetail } from "@/types"

const getListRuangCbtDetail = async (
  idsPeriodeParams?: string,
  isPenuhParams?: string,
  tanggalCbtParams?: string,
  jenisRuangParams?: string
) => {
  const response = await api.get("/setting/ruang-cbt-detail/index", {
    params: {
      ids_sys_periode: idsPeriodeParams,
      is_penuh: isPenuhParams,
      tanggal_cbt: tanggalCbtParams,
      jenis_ruang: jenisRuangParams,
    },
    withCredentials: true,
  })
  return response.data?.data
}

export default function RuangCbtDetailPage() {
  const [searchParams] = useSearchParams()
  const idsPeriodeParams = searchParams.get("ids_sys_periode") || ""
  const isPenuhParams = searchParams.get("is_penuh") || ""
  const tanggalCbtParams = searchParams.get("tanggal_cbt") || ""
  const jenisRuangParams = searchParams.get("jenis_ruang") || ""

  const { data, isPending } = useQuery({
    queryKey: [
      "listRuangCbtDetail",
      idsPeriodeParams,
      isPenuhParams,
      tanggalCbtParams,
      jenisRuangParams,
    ],
    queryFn: () =>
      getListRuangCbtDetail(
        idsPeriodeParams,
        isPenuhParams,
        tanggalCbtParams,
        jenisRuangParams
      ),
  })

  const filteredListData =
    data && data?.length > 0
      ? data?.filter((item: RuangCbtDetail) => {
          return item?.nama_jalur_jenis?.startsWith("SMBJM-CBT")
        })
      : []

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={filteredListData || []} columns={columns} />
    </div>
  )
}
